import axios from "./axios";

const CartService = {
	getCarts: async (sortKey = "updated_at", sortOrder = "asc") => {
		try {
			const response = await axios.get(
				`/all-cart?sortKey=${sortKey}&sortOrder=${sortOrder}`
			);
			return response.data.data;
		} catch (e) {
			console.error(e);
		}
	},
	notifyUser: async (cart_id) => {
		try {
			const response = await axios.get(`/notify-cart?cart_id=${cart_id}`);
			return response.data.data;
		} catch (e) {
			console.error(e);
		}
	},
};

export default CartService;
